export default "__VITE_ASSET__DhRscMG5__"